import type { Bulletin } from '@shared/types/Bulletin';

/**
 * Cumul annuel de l'exonération de l'art. 91 11° (et art. 347 al. 2 pour la TCS) : primes de performance, de
 * rendement, d'intéressement, gratifications, bonus, treizième mois, primes de fin d'année, exonérées « dans la limite
 * annuelle et globale de 4 000 000 FCFA » (CGI 2025, publié par la DGI).
 *
 * Le plafond est annuel : un bulletin ne peut exonérer que ce qu'il reste après les bulletins antérieurs de la même
 * année civile du même salarié. Les bulletins annulés ne comptent pas ; le bulletin de la période elle-même (recalcul)
 * ni les périodes suivantes ne comptent non plus.
 *
 * Limite connue : recalculer un mois ancien ne recalcule pas les mois suivants. Après un tel recalcul, relancer les
 * mois suivants dans l'ordre chronologique.
 */
export function cumulExoArt9111Anterieur(
  bulletins: readonly Pick<Bulletin, 'salarie_id' | 'periode' | 'exo_art91_11' | 'statut'>[],
  salarieId: string,
  periode: string,
): number {
  const annee = periode.slice(0, 4);
  // Un mois ne compte qu'une fois, même si des bulletins en double existent pour ce mois (données antérieures).
  const parMois = new Map<string, number>();
  for (const b of bulletins) {
    if (b.salarie_id !== salarieId) continue;
    if (b.statut === 'annule') continue;
    if (b.periode.slice(0, 4) !== annee || b.periode >= periode) continue;
    parMois.set(b.periode, Math.max(parMois.get(b.periode) ?? 0, b.exo_art91_11 ?? 0));
  }
  let cumul = 0;
  for (const exo of parMois.values()) cumul += exo;
  return cumul;
}
